import { OrderRouteItem } from '@aloft/toolkit-shared';
import { Typography } from '@aloft/toolkit-sui';

import { NavLink } from 'react-router-dom';

import seagullColoredLogo from '../../../assets/logos/seagull/seagull-colored.svg';
import { NavItemType } from './types.ts';
import { HeaderNavItem } from './HeaderNavItem.tsx';

export const HeaderDesktopTopNavLegacy = ({
  orderRouteItems,
  headerNavItems,
  getRoute,
}: {
  orderRouteItems: readonly OrderRouteItem[];
  headerNavItems: Record<OrderRouteItem, NavItemType>;
  getRoute: (item: NavItemType) => string;
}) => {
  const firstItemName = orderRouteItems[0];
  const firstItem = firstItemName ? headerNavItems[firstItemName] : undefined;

  return (
    <ul className="main-header-nav main-header-nav-legacy">
      {firstItem && (
        <li>
          <NavLink to={getRoute(firstItem)} className="main-header-nav-brand-link">
            <img
              src={seagullColoredLogo}
              alt="Appraisify"
              className="main-header-nav-brand-logo"
              width={30}
              height={30}
            />
            <Typography variant="h3" color="textPrimary">
              Depreciated Cost
            </Typography>
          </NavLink>
        </li>
      )}
      {orderRouteItems.map((itemName: OrderRouteItem) => {
        const item = headerNavItems[itemName];
        if (item.route === firstItem?.route) {
          return null;
        }
        return <HeaderNavItem key={item.route} item={item} to={getRoute(item)} isLegacyTopNav />;
      })}
    </ul>
  );
};
